<template>
  <div class="warp" v-loading="loading">
    <div class="warp-content">
      <div class="left">
        <div class="chunk-title">业主
          <el-select style="width:168px" size="small" v-model="proprietorIndex" @change="proprietorChange">
            <el-option v-for="(item,index) in tableData" :key="index" :value="index" :label="item.name"></el-option>
          </el-select>
        </div>
        <div class="flex-1">
          <el-tree ref="tree" highlight-current :data="treeAreaData" node-key="id" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
        </div>
      </div>
      <div class="right">
        <div class="chunk-title">
          <time-search ref="timeSearch" :control="{data:timeData}" @timeControlChange="timeControlChange" @timeControlClick="TimeControlClick" :showExportBtn="true" @exportExc="bindExportExc">
            <span class="typetext" style="padding-left:10px;">能源类型：</span>
            <el-select size="small" style="width:150px;" v-model="dataType" v-if="energyType">
              <el-option v-for="(item,index) in energyType" :key="index" :label="item.label" :value="item.id"></el-option>
            </el-select>
          </time-search>
        </div>
        <div class="flex-1">
          <nk-table id="table" :data="totalTableData" :noDataTitle="'该时间段暂无数据'" :columns="columns">
            <template v-for="(item,index) in timeColumns">
              <el-table-column :slot="item.prop" :label="item.label" width="80" align="center" :key="index">
                <template slot-scope="scope">
                  <div>{{scope.row[item.prop]}}</div>
                </template>
              </el-table-column>
            </template>
          </nk-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  exportExcel
} from '@/utils/index.js'
import api from '@common/api/index.js'
import utils from '@common/utils/index.js'
import Tree from "@/utils/tree.js";
import dateTool from "@/utils/dateTool.js"
import config from "@common/config/index.js"
import TimeSearch from '@/components/common/TimeSearch.vue'
import NkTable from '@/components/common/NkTable'
let allTimeData = [
  {
    type: 'day',
    label: '日',
  },
  {
    type: 'month',
    label: '月',
  },
  {
    type: 'year',
    label: '年',
  },
]
export default {
  components: { TimeSearch, NkTable },
  data () {
    return {
      timeData: allTimeData,
      energyType: [{ id: 1, label: '电' }, { id: 2, label: '水' }, { id: 3, label: '天然气' }, { id: 4, label: '柴油' }],
      selectedDate: {
        dateType: 'day',
        endTime: null,
        startTime: null,
      },
      dataType: 1,// 默认为电
      tableData: [],
      proprietorIndex: 0,
      treeAreaData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      selectedArea: null,
      switchData: [],
      socket: null,
      loading: false,
      totalTableData: [],
      columns: [
        {
          prop: 'name',
          label: '场地名称',
          fixed: 'left',
          width: 230,
          show: true,
          align: 'left',
        },
      ],
      timeColumns: []
    }
  },
  created () {
    let time = new Date()
    let startTime = dateTool.format(time, 'yyyy/MM/dd') + ' 00:00:00'
    time.setDate(time.getDate() + 1)
    let endTime = dateTool.format(time, 'yyyy/MM/dd') + ' 00:00:00'

    this.selectedDate = {
      dateType: 'day',
      startTime: startTime,
      endTime: endTime
    }
    this.getRentalArea()
  },
  methods: {
    getRentalArea () {
      api.rentalArea.getRentalAreaTrusteeshipContractForProperty(null, null, null, null, null, null, 1).then(res => {
        if (res.data) {
          let tableData = []
          for (let i = 0; i < res.data.length; i++) {
            const element = res.data[i];
            let proprietorIndex = tableData.findIndex(c => c.id === element.proprietorCompanyId)
            if (proprietorIndex == -1) {
              tableData.push({ id: element.proprietorCompanyId, name: element.proprietorCompanyName, children: [] })
              proprietorIndex = tableData.length - 1
            }
            for (let j = 0; j < element.areas.length; j++) {
              const area = element.areas[j];
              let areaIndex = tableData[proprietorIndex].children.findIndex(c => c.id === area.id)
              if (areaIndex == -1) {
                tableData[proprietorIndex].children.push(area)
              }
            }
          }
          this.tableData = tableData
          this.proprietorChange(0)
        }
        else {
          this.tableData = []
          this.selectedArea = null
          this.switchData = []
        }
      })
    },
    proprietorChange (val) {
      let areasId = []
      for (let i = 0; i < this.tableData[val].children.length; i++) {
        areasId.push(this.tableData[val].children[i].id)
      }

      api.rentalArea.getSubRentalAreas(areasId, 1).then(res => {
        if (res && res.data) {
          this.treeAreaData = utils.companyDataToCompanyTree(res.data)
          if (this.treeAreaData.length > 0) {
            this.selectedArea = this.treeAreaData[0]
            this.$nextTick(() => {
              this.$refs.tree.setCurrentKey(this.selectedArea.id)
            })
            this.getRentalAreaEnergyCost()
          }
          else {
            this.treeAreaData = []
            this.selectedArea = null
          }
        }
      })
    },
    handleNodeClick (data, nodde, el) {
      this.selectedArea = data
      this.getRentalAreaEnergyCost()
    },
    timeControlChange () {
    },
    //查询事件
    TimeControlClick (e) {
      let vm = this
      vm.selectedDate = e
      vm.selectedDate.dataType = vm.dataType
      this.getRentalAreaEnergyCost()
    },

    getRentalAreaEnergyCost () {
      console.log(this.selectedDate)
      let areaArr = Tree.treeArrToArr([this.selectedArea])
      let tableData = []
      let areas = []
      for (let i = 0; i < areaArr.length; i++) {
        areas.push(areaArr[i].id)
        tableData.push({ id: areaArr[i].id, name: areaArr[i].name })
      }
      let apiFuncName = null
      let timeLabels = []
      let startTimeLabel = ''
      switch (this.selectedDate.dateType) {
        case 'day':
          apiFuncName = 'getRentalAreaEnergyCostHour'
          startTimeLabel = dateTool.format(new Date(this.selectedDate.startTime), 'yyyy/MM/dd')
          for (let i = 0; i < 24; i++) {
            timeLabels.push({ index: i, label: i + '时', value: startTimeLabel + ' ' + (i < 10 ? '0' + i : i) + ':00:00' })
          }
          this.addColumns(24, 0, '时')
          break;
        case 'month':
          apiFuncName = 'getRentalAreaEnergyCostDay'
          let newDate = new Date(this.selectedDate.startTime)
          let days = new Date(newDate.getFullYear(), newDate.getMonth(), 0).getDate()
          startTimeLabel = dateTool.format(new Date(this.selectedDate.startTime), 'yyyy/MM')
          for (let i = 0; i < days; i++) {
            timeLabels.push({ index: i, label: (i + 1) + '号', value: startTimeLabel + '/' + (i < 10 ? '0' + i : i) + ' ' + ' 00:00:00' })
          }
          this.addColumns(days, 1, '号')
          break;
        case 'year':
          apiFuncName = 'getRentalAreaEnergyCostMonth'
          startTimeLabel = dateTool.format(new Date(this.selectedDate.startTime), 'yyyy')
          for (let i = 0; i < 12; i++) {
            timeLabels.push({ index: i, label: (i + 1) + '月', value: startTimeLabel + '/' + (i < 9 ? '0' + (i + 1) : (i + 1)) + '/01 00:00:00' })
          }
          this.addColumns(12, 1, '月')
          break;
      }
      console.log(apiFuncName)
      api.rentalArea[apiFuncName](areas, this.dataType, this.selectedDate.startTime, this.selectedDate.endTime).then(res => {
        if (res.data) {
          let data = res.data
          for (let i = 0; i < tableData.length; i++) {
            const tr = tableData[i]
            for (let j = 0; j < timeLabels.length; j++) {
              const timeLabelItem = timeLabels[j]

              for (let k = 0; k < data.length; k++) {
                const resData = data[k];
                // 判断返回数据的time与xData的time相符的项
                const dataItem = resData.find(c => c.id === tr.id && c.time === timeLabelItem.value)
                if (dataItem) {
                  let total = '-'
                  let quantity = '-'
                  let distributedQuantity = '-'
                  if (dataItem.energy && dataItem.energy.length > 0) {
                    total = dataItem.energy[0].total === null ? total : dataItem.energy[0].total
                    if (dataItem.energy[0].measuringBasic && dataItem.energy[0].measuringBasic.length > 0) {
                      quantity = dataItem.energy[0].measuringBasic[0].quantity === null ? quantity : dataItem.energy[0].measuringBasic[0].quantity
                    }
                    if (dataItem.energy[0].measuringDistribution && dataItem.energy[0].measuringDistribution.length > 0) {
                      distributedQuantity = dataItem.energy[0].measuringDistribution[0].distributedQuantity === null ? quantity : dataItem.energy[0].measuringDistribution[0].distributedQuantity
                    }
                  }

                  tr['total' + timeLabelItem.index] = total === '-' ? total : total.toFixed(2)
                  tr['quantity' + timeLabelItem.index] = quantity === '-' ? quantity : quantity.toFixed(2)
                  tr['distributedQuantity' + timeLabelItem.index] = distributedQuantity === '-' ? distributedQuantity : distributedQuantity.toFixed(2)
                }
              }
            }
          }

          this.totalTableData = tableData
        }
      })
    },

    addColumns (length, base = 0, text = '') {
      let columns = []
      for (let i = 0; i < length; i++) {
        columns.push({
          prop: 'total' + i,
          label: (i + base) + text,
          fixed: 'left',
          slot: 'total' + i,
        })
      }

      this.timeColumns = columns

      let oldColumns = [
        {
          prop: 'name',
          label: '场地名称',
          fixed: 'left',
          width: 230,
          show: true,
          align: 'left',
        },
      ]

      this.columns = oldColumns.concat(columns)
    },

    bindExportExc () {
      //表格导出
      let name = '场地抄表'
      exportExcel('table', name, this.selectedDate)
    },
  }
}
</script>

<style lang="scss" scoped>
.warp {
  width: 100%;
  height: 100%;
  padding: 14px;
  box-sizing: border-box;
  .warp-content {
    width: 100%;
    height: 100%;
    padding: 10px;
    background: #fff;
    color: #2e3842;
    text-align: left;
    box-sizing: border-box;
    display: flex;
    .left {
      flex: 0 0 200px;
      overflow: auto;
      display: flex;
      flex-flow: column;
    }
    .right {
      margin-left: 10px;
      flex: 1;
      display: flex;
      flex-flow: column;
      overflow: auto;
      .list {
        width: 100%;
        height: 100%;
        overflow: auto;
        .item {
          width: 240px;
          height: 100px;
          border-radius: 4px;
          border: 1px solid #eee;
          float: left;
          margin-right: 10px;
          margin-bottom: 10px;
          .btn {
            height: 30px;
            background: #eee;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            border-radius: 0px 0px 4px 4px;
            &:hover {
              background: #409eff;
              color: #fff;
            }
          }
        }
      }
    }
    .chunk-title {
      flex: 0 0 30px;
      line-height: 30px;
      margin-bottom: 10px;
    }
    .flex-1 {
      flex: 1;
      overflow: auto;
    }
    .flex {
      display: flex;
      align-items: center;
      height: 30px;
      overflow: auto;
    }
    .flex-60 {
      flex: 0 0 70px;
      text-align: right;
    }
    .break-space {
      width: 100%;
      overflow: hidden;
      white-space: break-spaces;
    }
  }
}
</style>